import React from 'react';
import { IconCircleCheck, IconAlertTriangle } from '@tabler/icons-react';
import { QualityResult, describeQuality } from 'helpers/imageQuality';
import styles from './QualityGateOverlay.module.scss';

interface QualityGateOverlayProps {
    dataUrl: string;
    result: QualityResult | null; // null while still assessing
    onAccept: () => void;
    onRetake: () => void;
}

const QualityGateOverlay = ({ dataUrl, result, onAccept, onRetake }: QualityGateOverlayProps) => {
    const assessing = result === null;
    const pass = !!result?.pass;

    return (
        <div className={styles.review}>
            <div className={styles.preview}>
                <img src={dataUrl} alt="Captured preview" className={styles.image} />
            </div>

            <div className={`${styles.verdict} ${assessing ? '' : pass ? styles.pass : styles.fail}`}>
                {!assessing && (pass
                    ? <IconCircleCheck className={styles.verdictIcon} />
                    : <IconAlertTriangle className={styles.verdictIcon} />)}
                <span className={styles.verdictText}>
                    {assessing ? 'Checking photo…' : describeQuality(result!)}
                </span>
            </div>

            <div className={styles.actions}>
                {pass ? (
                    <>
                        <button type="button" className={styles.secondary} onClick={onRetake} disabled={assessing}>
                            Retake
                        </button>
                        <button type="button" className={styles.primary} onClick={onAccept} disabled={assessing}>
                            Use Photo
                        </button>
                    </>
                ) : (
                    <>
                        <button type="button" className={styles.primary} onClick={onRetake} disabled={assessing}>
                            Retake
                        </button>
                        <button type="button" className={styles.link} onClick={onAccept} disabled={assessing}>
                            Use anyway
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default QualityGateOverlay;
